import { Card, Box, styled } from "@mui/material";
import { ReactNode, FC } from "react";

interface SimpleCardProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

const CardRoot = styled(Card)({
  height: "100%",
  padding: "20px 24px",
  backgroundColor: "#f5f5f5"
});

const CardTitle = styled("div")<{ subtitle?: string }>(({ subtitle }) => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize",
  marginBottom: !subtitle ? "16px" : "0",
}));

const SimpleCard: FC<SimpleCardProps> = ({ children, title, subtitle }) => {
  return (
    <CardRoot elevation={6}>
      <CardTitle subtitle={subtitle}>{title}</CardTitle>
      {subtitle && <Box mb={2}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;